import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container, Button, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
import usePost from '../../helpers/hooks/usePost';

import { AddRaqba } from './add-raqba';

import { RaqbasList } from './raqbas-list';

export const Raqbas = (props) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [raqbas, , raqbasLoading, loadRaqbas] = useGet(
    '/field-areas?filter[order]=createdAt DESC',
    true
  );
  const [postData, postedData, postingError, dataPosting] = usePost(
    '/field-areas'
  );
  const [updateData, updatedData, updatingError, dataUpdating] = usePatch('');
  const handleAddNewRaqba = (event, errors, values) => {
    console.log(values, errors);
    if (errors.length === 0) {
      postData({ ...values, isActive: true });
    }
  };
  const handleRaqbaPatch = (id, data) => {
    updateData(data, `/field-areas/${id}`);
  };
  useEffect(() => {
    if (postedData) {
      setShowAddForm(false);
      loadRaqbas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postedData]);
  useEffect(() => {
    if (updatedData) {
      loadRaqbas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Raqbas</h4>
            <Button
              color='primary'
              onClick={() => setShowAddForm(!showAddForm)}
            >
              Add New Raqba
            </Button>
          </div>
          {showAddForm && (
            <AddRaqba onAdd={handleAddNewRaqba} disabled={dataPosting} />
          )}
          <Card>
            <CardBody>
              {raqbasLoading || dataUpdating ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <RaqbasList
                  onUpdate={handleRaqbaPatch}
                  data={raqbas?.map((x, i) => ({
                    ...x,
                    srNo: i + 1,
                    createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
                    updatedAt: dayjs(x.updatedAt).format('DD/MM/YYYY'),
                  }))}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};
